import { render, staticRenderFns } from "./CostCurve.vue?vue&type=template&id=900392d6&scoped=true"
import script from "./CostCurve.vue?vue&type=script&lang=js"
export * from "./CostCurve.vue?vue&type=script&lang=js"
import style0 from "./CostCurve.vue?vue&type=style&index=0&id=900392d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900392d6",
  null
  
)

export default component.exports